/**
 * Floating label list for the Errors bucket (sibling of the Manual Actions popup).
 * Rows are multi-select: a selected row is bold with a highlighted background. "All errors" (first row)
 * selects the union of every error label. Row labels are the raw aggregated error message (no translation).
 */
import { observer } from "mobx-react";
import "./rma-list-errors-popup.scss";
import useDashboardTranslation from "../../../../../../../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import { RmaListBucketFiltersStore } from "../../../../../../../../../rma-list-page/stores/rma-list-bucket-filters-store";
import RmaListErrorsPopupRow from "./components/rma-list-errors-popup-row/rma-list-errors-popup-row";

interface IProps {
    bucketFiltersStore: RmaListBucketFiltersStore;
    onToggle: (value: string) => void;
    onToggleAll: () => void;
}

const RmaListErrorsPopup: React.FC<IProps> = observer(({ bucketFiltersStore, onToggle, onToggleAll }) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = "dashboard-returns-page";

    const selected = bucketFiltersStore.selectedErrorLabels;
    const allSelected = bucketFiltersStore.areAllErrorsSelected;

    return (
        <div className="rma-list-errors-popup">
            <RmaListErrorsPopupRow
                label={getTranslation("ALL_ERRORS", scope)}
                count={bucketFiltersStore.errorsTotal}
                isSelected={allSelected}
                onToggle={onToggleAll}
            />
            {bucketFiltersStore.errorOptions.map((option) => (
                <RmaListErrorsPopupRow
                    key={option.value}
                    label={option.value}
                    count={option.count}
                    isSelected={selected.includes(option.value)}
                    onToggle={() => onToggle(option.value)}
                />
            ))}
        </div>
    );
});

export default RmaListErrorsPopup;
